import React from 'react';
import { IS_HUIYA, getSiteName } from '../config/domain';
import { getHostname } from '../utils/domainTestHelper';

/**
 * 域名调试组件，在页面上显示当前域名和站点名称
 * 仅在开发环境中显示
 */
const DomainDebugger: React.FC = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const siteName = getSiteName();
  const hostname = getHostname();
  
  const style: React.CSSProperties = {
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '10px',
    borderRadius: '5px',
    fontSize: '12px',
    zIndex: 9999,
  };

  return (
    <div style={style}>
      <div>域名: {hostname}</div>
      <div>站点: {siteName}</div>
      <div>IS_HUIYA: {IS_HUIYA ? '是' : '否'}</div>
      <div>
        <a 
          href="?domain=huiya" 
          style={{color: 'yellow', marginRight: '10px'}}
        >
          切换到绘芽
        </a>
        <a 
          href="?domain=deerbook" 
          style={{color: 'yellow'}}
        >
          切换到奇鹿
        </a>
      </div>
    </div>
  );
};

export default DomainDebugger; 